import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminDashboardKeys } from 'app/queries/adminDashboard/adminDashboardKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminDashboardKeys.info>>;

export const createFetchDashboardInfoQueryFn =
  (call: TCall) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getDashboardInfo(), signal));
